import { flagDE, flagEN, flagES, flagFR, flagIT, flagNL, flagPT, flagPL } from '@infuse/ui/assets/flags';

export const languages = [
  {
    id: 1,
    label: 'Nederlands',
    value: 'nl',
    flag: flagNL,
    emoji: '🇳🇱'
  },
  {
    id: 2,
    label: 'English',
    value: 'en',
    flag: flagEN,
    emoji: '🇬🇧'
  },
  {
    id: 3,
    label: 'Deutsch',
    value: 'de',
    flag: flagDE,
    emoji: '🇩🇪'
  },
  {
    id: 4,
    label: 'Français',
    value: 'fr',
    flag: flagFR,
    emoji: '🇫🇷'
  },
  {
    id: 5,
    label: 'Español',
    value: 'es',
    flag: flagES,
    emoji: '🇪🇸'
  },
  {
    id: 6,
    label: 'Italiano',
    value: 'it',
    flag: flagIT,
    emoji: '🇮🇹'
  },
  {
    id: 7,
    label: 'Português',
    value: 'pt',
    flag: flagPT,
    emoji: '🇵🇹'
  },
  {
    id: 8,
    label: 'Polski',
    value: 'pl',
    flag: flagPL,
    emoji: '🇵🇱'
  }
];
